import React from 'react';

interface CheckmarkIconProps extends React.SVGProps<SVGSVGElement> {}

const CheckmarkIcon: React.FC<CheckmarkIconProps> = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="12" cy="12" r="11.5" fill="white" stroke="#96F7E1" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.15161 11.5456L10.788 15.1819L16.8486 9.12134" stroke="#001417" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default CheckmarkIcon;
